export default defineAppConfig({
  ui: {
    theme: {
      colors: ['primary', 'info', 'success', 'warning', 'error', 'neutral'],
    },
    colors: {
      neutral: 'gray',
    },
    alert: {
      slots: {
        close: 'justify-end',
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'subtle',
          class: {
            root: 'bg-primary-100 text-gray-900 ring ring-inset ring-primary-300',
            title: 'font-bold',
            icon: 'text-primary-600',
          },
        },
      ],
    },
    container: {
      base: 'w-full max-w-(--ui-container) mx-auto px-4 sm:px-6 lg:px-8 xl:px-9',
    },
    button: {
      defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'sm',
      },
    },
    input: {
      slots: {
        root: 'block',
      },
    },
    inputMenu: {
      slots: {
        root: 'block',
      },
    },
    textarea: {
      slots: {
        root: 'block',
      },
    },
    formField: {
      slots: {
        label: 'text-gray-700 truncate text-sm font-bold',
      },
    },
    modal: {
      slots: {
        footer: 'justify-end gap-4',
      },
    },
    card: {
      slots: {
        header: 'p-3 sm:p-5',
        body: 'p-3 sm:p-5',
        footer: 'p-3 sm:p-5',
      },
      variants: {
        variant: {
          outline: {
            root: 'bg-default ring ring-default divide-none',
          },
        },
      },
    },
    badge: {
      defaultVariants: {
        color: 'primary',
        variant: 'soft',
        size: 'md',
      },
    },

    carousel: {
      slots: {
        dots: 'bottom-4 gap-2',
        dot: ['size-2 bg-white opacity-50'],
      },
      variants: {
        orientation: {
          horizontal: {
            prev: 'start-4 sm:start-4 top-1/2 -translate-y-1/2',
            next: 'end-4 sm:end-4 top-1/2 -translate-y-1/2',
          },
        },

        active: {
          true: {
            dot: 'data-[state=active]:opacity-80 data-[state=active]:bg-white',
          },
        },
      },
    },
    pageGrid: {
      base: 'gap-4',
    },

    link: {
      compoundVariants: [
        {
          active: true,
          disabled: false,
          class: ['hover:opacity-75', 'transition-opacity'],
        },
      ],
    },
  },
})
